<template>
	<div v-show="loadingSubstudy">
		<div class="progress-bar progress-bar-striped active" role="progressbar"
		aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width:100%">
		  Loading&hellip;
		</div>
	</div>
	<div v-show="!loadingSubstudy">
		<h3>
			<a href="/substudies">Substudies</a>:
			{{ substudy.name }}
			<span class="badge">
				{{ (substudy.active == 1) ? 'Active' : 'Inactive' }}
			</span>
		</h3>
		<hr />
		<div class="alert alert-info" v-show="showAllUpdateWarning">
			⏳ Updating selected participants. This could take a little while.  Thanks for your patience&hellip;
		</div>
		<div class="alert alert-info" v-show="loadingParts">Loading&hellip;</div>
		<review-table 
			v-if="!loadingParts" 
			:substudy="substudy"
			:uncheckParticipants="uncheckParticipants"
			:participants="participants"
			:showstatus="true"
			v-on:canceltask="cancelTask"
			v-on:taskcreated="updateTask"
			v-on:taskscreated="fetchSubstudyParticipants"
			v-on:changewindow="updateVisitWindow"
			v-on:updateparticipants="showPartsUpdate"
			v-on:assignparticipant="assignParticipant"
			v-on:participantchanged="fetchSubstudyParticipants"
			>
			<!-- v-on:updateWindow="updateVisitWindow($event)" -->
		</review-table>
	</div>
	<div class="alert alert-info floating-feedback" v-if="message">
		<small>{{ message }}</small>
	</div>
	<div class="alert alert-info floating-feedback" v-if="updating">
		<small>Updating&hellip;</small>
	</div>
	<substudy-part-update
		v-model:showModal="showUpdateModal"
		v-on:confirm="saveUpdate($event)"
	></substudy-part-update>
</template>

<script setup>
	import { ref, onMounted, computed } from 'vue'
	import SubstudyResource from '../../resources/SubstudyResource.js';
	import ReviewTable from '../ReviewTable.vue';
	import SubstudyPartUpdate from './SubstudyPartUpdate.vue';
	
	const props = defineProps(['substudyId'])
	
	const substudy = ref({})
	const loadingSubstudy = ref(true)
	const loadingParts = ref(true)
	const participants = ref([])
	const uncheckParticipants = ref(false)
	const message = ref(null)
	const updating = ref(false)
	const showUpdateModal = ref(false)
	const selectedParticipants = ref([])
	const showAllUpdateWarning = ref(false)

	onMounted(() => {
		fetchSubstudy()
		fetchSubstudyParticipants()
	})

	function updateParticipant(participant) {
		var index = participants.value.findIndex(function (itm) {
			return itm.id == participant.id
		});
		participants.value.splice(index, 1, participant)
		updating.value = false;
	}

	function triggerMessage(msg) {
		message.value = msg;
		setTimeout(function () {
			message.value = null
		}.bind(this), 4000)
	}

	function cancelTask(participant) {
		fetchSubstudyParticipants();
		triggerMessage('Substudy task canceled for '+participant.full_name);
	}

	function updateTask({participant}) {
		fetchSubstudyParticipants();
	}

	function updateVisitWindow({participant}) {
		fetchSubstudyParticipants();
		triggerMessage('Substudy task window updated to '+participant.upcoming_task.visit_window_id+' for '+participant.full_name)
	}

	function fetchSubstudy() {
		SubstudyResource.find(props.substudyId)
			.then(function (response) {
				substudy.value = response.data
				loadingSubstudy.value = false;
			}.bind(this))
			.catch(function(error){
				console.error(error);
			})
	}

	function fetchSubstudyParticipants() {
		loadingParts.value = true;
		SubstudyResource.participants.all(props.substudyId)
			.then(function (response) {
				participants.value = response.data;
				loadingParts.value = false;
			}.bind(this))
	}

	function showPartsUpdate(evt) {
		selectedParticipants.value = evt.participants;
		showUpdateModal.value = true;
	}

	function assignParticipant(evt) {
		SubstudyResource.participants
			.assignParticipant(substudy.value, evt.participant)
			.then(function (response) {
				SubstudyResource.participants.find(substudy.value.id, evt.participant.id)
					.then(function(response){
						updateParticipant(response.data)
					}.bind(this));
			}.bind(this))
	}

	function saveUpdate(data) {
		uncheckParticipants.value = false
		showAllUpdateWarning.value = true;
		SubstudyResource.participants.updateParticipants(substudy.value, {
			'participants': selectedParticipants.value,	
			'eligibility_id': data.eligibility_id, 
			'substudy_status_id': data.substudy_status_id
		}).then(response => {
			fetchSubstudyParticipants();
			showUpdateModal.value =	showAllUpdateWarning.value = false
			uncheckParticipants.value = true
		})
	}

	const assignedParticipants = computed(() => {
		return participants.value.filter(function (item) {
			return item.assigned == 1
		})
	})

	const unassignedParticipants = computed(() => {
		return participants.value.filter(function (item) {
			return item.assigned == 0
		})
	})
</script>